import { useEffect, useState, useRef } from "react";
import detailsJSon from '../../data/structure/structure.json';
import calligraphyJson from '../../data/quran/mushaf/calligraphy/calligraphy.json';

const GlobalSearch=()=>{
    const [searchQuery,setSearchQuery]=useState("");
    const [isSearchInitiated,setIsSearchInitiated]=useState(false);
    const [matchingNavigationItems,setMatchingNavigationItems]=useState(null);
    const [matchingHistoryItems,setMatchingHistoryItems]=useState(null);
    const [isListening, setIsListening] = useState(false);
    const [isVoiceSearchReady,setIsVoiceSearchReady]=useState(false);
    const inputRef = useRef(null);

    const isItAllArabic =s=>(!/[^\u0600-\u06FF\u0020-\u0040\u005B-\u0060\u007B-\u007E]/.test(s));

    const sanitizeSearchString=(str)=>{
        str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
        return str.trim();
    }

    const normalizeSearchText = (text) => {
        return text
            .toLowerCase()                            // Convert to lowercase
            .normalize("NFD")                         // Decompose accents
            .replace(/[\u0300-\u036f]/g, "")           // Remove diacritics
            .replace(/[^a-z0-9]/g, "")                 // Remove everything except letters and numbers
            .trim();                                  // Trim whitespace
    };

    const matchWithRegex = (searchText, searchQuery) => {
        // Escape backslashes and other special regex characters
        const escapedSearchQuery = searchQuery
            .replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') // Escape special regex characters
            .replace(/[\s\-_\.]+/g, "[-_\\s\\.]*"); // Allow flexible matching
    
        const regex = new RegExp(escapedSearchQuery, "i"); // Create the regex object with the escaped query
        return regex.test(searchText);
    };    

    const doGlobalSearch = (searchQuery) => {
        // Retrieve local search history from localStorage
        let localSearchHistory = JSON.parse(localStorage.getItem('localSearchHistory'));
    
        // If localSearchHistory is null, create an array with the search term
        if (localSearchHistory === null) {
            localSearchHistory = [{
                searchTerm: searchQuery
            }];
        } else {
            // Check if the search term already exists in the array
            const existingIndex = localSearchHistory.findIndex(item => item.searchTerm === searchQuery);
    
            if (existingIndex !== -1) {
                // If search term exists, remove it from its current position
                localSearchHistory.splice(existingIndex, 1);
            }
    
            // Add the search term to the beginning of the array
            const historyObj = {
                searchTerm: searchQuery
            };
            localSearchHistory.unshift(historyObj);
    
            // If the array length exceeds 10, remove the last (oldest) item
            if (localSearchHistory.length > 10) {
                localSearchHistory.pop(); // Remove the last item
            }
        }
    
        // Set the updated search history back to localStorage
        localStorage.setItem("localSearchHistory", JSON.stringify(localSearchHistory));
    
        // Ensure that the local storage is updated, then redirect
        if (localStorage.getItem('localSearchHistory')) {
            // Redirect to the search results page after ensuring storage is set
            window.location = `/search-results?s=${searchQuery}&page=1`;
        } else {
            console.error("Failed to update localStorage");
        }
    };

    const startGlobalSearch=(event)=>{
        event.preventDefault();
        const search_query = searchQuery;
        const sanitizedQuery=isItAllArabic(search_query)?search_query:sanitizeSearchString(search_query);
        // window.location="/search-results?s="+sanitizedQuery+"&page=1";
        doGlobalSearch(sanitizedQuery)
    }

    const clearGlobalSearch=()=>{
        setSearchQuery("");
        setIsSearchInitiated(false);
    }

    const closeSearchTile = (indexToRemove, titleType) => {
        if(titleType==="history")
        {
            setMatchingHistoryItems((prevItems) =>
                prevItems.filter((_, index) => index !== indexToRemove)
            );
        }
        else
        {
            setMatchingNavigationItems((prevItems) =>
                prevItems.filter((_, index) => index !== indexToRemove)
            );
        }
    };

    // Check if SpeechRecognition is available
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    const recognition = SpeechRecognition ? new SpeechRecognition() : null;

    if (recognition) {
        if(!isVoiceSearchReady)
        {
            setIsVoiceSearchReady(true);
        }
        recognition.lang = "en-US";
        recognition.continuous = false;
        recognition.interimResults = false;

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            // Clean transcript to remove unwanted characters
            const cleanTranscript = transcript.replace(/[^a-zA-Z0-9\s]/g, "");
            setSearchQuery(cleanTranscript); // Update search query
            resetListenState();
            if (inputRef.current) {
                inputRef.current.focus();
            }
            //initiateSearch(cleanTranscript); // Call initiateSearch function
        };

        recognition.onerror = (event) => {
            console.error("Speech recognition error:", event.error);
            resetListenState();
        };
    }

    const showListenState = () => {
        setIsListening(true);
    };

    const resetListenState = () => {
        setIsListening(false);
    };

    const handleVoiceSearchClick = () => {
        if (recognition) {
            recognition.start();
            showListenState();
        }
    };

    const setMushafLocalStorage=(surahId,sName)=>{
        return Promise.resolve().then(function () {
            const surahData={snum:surahId,sname:sName}
            localStorage.setItem("mushafSurahSidebar", JSON.stringify(surahData));
        });
    }

    const navigateMushaf=(surId, mushafPage)=>{
        let page = null;

        const ayahObj = calligraphyJson.find(
            (ayah) => ayah.SurahNumber === surId.toString() && ayah.AyahNumber === '1'
        );
        
        if (ayahObj) {
            page = ayahObj.pageNo;
        }

        const surahData=detailsJSon[parseInt(surId)-1];

        const finalPage = Number(mushafPage)>Number(page)?mushafPage:page;

        console.log(ayahObj, surahData, finalPage, surId);
        
    
        if(ayahObj&&surahData)
        {
            setMushafLocalStorage(parseInt(surahData.index).toString(), surahData.title).then(function() {
                window.location = '/quran/read-mushaf/' + finalPage;
            });
        }
    }

    const navigateToResultPage = (pageType, insightData) => {
        if(pageType==="Mushaf")
        {
            navigateMushaf(insightData.surahNumber, insightData.scrollPos);
        }
        else
        {
            window.location=`/quran/${pageType==="Read"?`read-surah`:`recite-surah`}/${parseInt(insightData.surahNumber)}`
        }
    }

    useEffect(()=>{
        if(searchQuery!=="")
        {
            // Retrieve local search history from localStorage
            const localSearchHistory = JSON.parse(localStorage.getItem('localSearchHistory')) || [];

            // Find all matching items in localSearchHistory
            const matchingHistoryItems = localSearchHistory.filter(item => normalizeSearchText(item.searchTerm).includes(normalizeSearchText(searchQuery)));

            setMatchingHistoryItems(matchingHistoryItems);

            // Retrieve data from localStorage and handle null cases
            const localSurahs = JSON.parse(localStorage.getItem('recentInsights')) ?? [];
            const hadithHistory = JSON.parse(localStorage.getItem('hadithHistory')) ?? [];
            const translationHistory = JSON.parse(localStorage.getItem('recentTranslation')) ?? [];
            const tafsirHistory = JSON.parse(localStorage.getItem('recentTafsir')) ?? [];

            // Update field names directly while mapping
            const updatedTranslationHistory = translationHistory.map(({ type, ...rest }) => ({
                ...rest,
                translationType: type // Rename 'type' to 'translationType'
            }));

            const updatedTafsirHistory = tafsirHistory.map(({ type, ...rest }) => ({
                ...rest,
                tafsirType: type // Rename 'type' to 'tafsirType'
            }));

            // Merge arrays efficiently
            const mergedArray = [
                ...localSurahs,
                ...hadithHistory,
                ...updatedTranslationHistory,
                ...updatedTafsirHistory
            ];

            const filteredNaviagtions = mergedArray.filter((navItem) => {
                const localSurahName = navItem.hasOwnProperty('hadithName')
                    ? normalizeSearchText(`${navItem.hadithName}`)
                    : normalizeSearchText(`${parseInt(navItem.surahNumber)}. ${navItem.title}`);
            
                return matchWithRegex(localSurahName, searchQuery);
            });

            setMatchingNavigationItems(filteredNaviagtions);
        }
    },[searchQuery]);

    return(
        <>
            <form onSubmit={startGlobalSearch} className="flex relative w-full mx-auto alim-search-box px-8" autoComplete="off">
                <button type="button" onClick={clearGlobalSearch} className="block bg-transparent absolute left-9 top-2">
                    {
                        isSearchInitiated?
                            <span className="block modal-close-img-elem w-[15px] h-[15px] mt-1"></span>
                        :
                            <span className="block search-img-elem w-[22px] h-[22px]"></span>
                    }
                </button>
                <input required ref={inputRef} type="text" name="search-term" className="focus:ring-0 h-12 mb-5 flex bg-transparent text-gray-900 placeholder:text-gray-400 text-lg alim-text-color-style focus:outline-none border-t-0 border-x-0 border-b border-light-beige dark:border-white/30 w-full px-12 pt-2 pb-4" 
                value={searchQuery}
                placeholder={isListening ? "Listening..." : "What would you like to explore?"}
                onChange={(e)=>{
                    const inputValue=e.target.value
                    setSearchQuery(inputValue);
                    if(inputValue!=="")
                    {
                        setIsSearchInitiated(true);
                    }
                    else
                    {
                        setIsSearchInitiated(false);
                    }
                }}/>
                {
                    isVoiceSearchReady?
                        <button type="button" className="block bg-transparent absolute right-10 top-2" title="Search using voice" onClick={handleVoiceSearchClick}>
                            {isListening ? (
                                <img src="/images/audio-wave.gif" alt="Listening" className="h-6 w-6" />
                            ) : (
                                <img src="/images/mic.svg" alt="voice-search-icon" width="17" height="22"/>
                            )}
                        </button>
                    :
                        null
                }
            </form>
            <div className="alim-text-color-style flex flex-col w-full px-8 overflow-auto">
                {
                    matchingNavigationItems&&searchQuery!==""?
                        matchingNavigationItems.length>0?
                            <>
                                <p className="text-sm mt-5">Recent navigations:</p>
                                {
                                    matchingNavigationItems.map((navItem, index)=>{
                                        if(navItem.hasOwnProperty('hadithName'))
                                        {
                                            return(
                                                <div key={index} className="global-surahs search-item">
                                                    <a href={navItem.hURI} className="grid grid-cols-12 gap-3 w-full py-4" target="_blank">
                                                        <div className="col-span-12 relative md:pl-5 flex items-center">
                                                            <div className="search-arrow-img-elem w-[18px] h-[14px]"></div>
                                                            <span id="global-surah-title${snum}" className="ml-2 block">{navItem.hadithName}</span>
                                                        </div>
                                                    </a>
                                                    <button className="cursor-pointer rounded-full bg-light-blue/10 dark:bg-white/10 h-8 w-8 flex justify-center items-center close-container" onClick={() => closeSearchTile(index,'navigation')}>
                                                        <div className="modal-close-img-elem w-[12px] h-[12px]"></div>
                                                    </button>
                                                </div>
                                            )
                                        }
                                        else if(navItem.hasOwnProperty('pageType'))
                                        {  
                                            const pageType = navItem.pageType?.includes("recite")? 
                                                            `Recite`
                                                        :
                                                           navItem.pageType?.includes("mushaf")? 
                                                                `Mushaf`
                                                            :   
                                                                `Read`;
                                            return(
                                                <div key={index} className="global-surahs search-item">
                                                    <div className="grid grid-cols-12 gap-3 w-full py-4 cursor-pointer" onClick={()=>navigateToResultPage(pageType, navItem)}>
                                                        <div className="col-span-12 md:col-span-5 relative md:pl-5 flex items-center">
                                                            <div className="search-arrow-img-elem w-[18px] h-[14px] min-w-[18px] min-h-[14px]"></div>
                                                            <span id="global-surah-title${snum}" className="ml-2 block">{parseInt(navItem.surahNumber)}. {navItem.title} ({pageType})</span>
                                                        </div>
                                                        <div className="col-span-2 text-center flex items-center hidden md:block">
                                                            <p>Juz {navItem.juz}</p>
                                                        </div>
                                                        <div className="col-span-2 text-center flex items-center justify-center hidden md:block">
                                                            <p>{navItem.ayahCount} Ayahs</p>
                                                        </div>
                                                        <div className="col-span-3 text-center flex items-center justify-center hidden md:block">
                                                            <p>{navItem.arbTitle}</p>
                                                        </div>
                                                    </div>
                                                    <button className="cursor-pointer rounded-full bg-light-blue/10 dark:bg-white/10 h-8 w-8 flex justify-center items-center close-container" onClick={() => closeSearchTile(index,'navigation')}>
                                                        <div className="modal-close-img-elem w-[12px] h-[12px]"></div>
                                                    </button>
                                                </div>
                                            )
                                        }
                                        else if(navItem.hasOwnProperty('translationType'))
                                        {
                                            const pageUri=navItem.translationType==="compare"?`/quran/compare/surah/${Number(navItem.surahNumber)}/${navItem.ayahNumber}`:`/translation/${navItem.translationType}/${Number(navItem.surahNumber)}`;

                                            const getTranslationType=(type)=>{
                                                switch(type)
                                                {
                                                    case "asad":
                                                        return "Asad"; 
                                                    case "malik":
                                                        return "Malik";
                                                    case "khattab":
                                                        return "Mustafa Khattab";
                                                    case "picktal":
                                                        return "Picktal";
                                                    case "yusuf-ali":
                                                        return "Yusuf Ali";
                                                    default:
                                                        return "Compare";
                                                }
                                            }

                                            return(
                                                <div key={index} className="global-surahs search-item">
                                                    <a href={pageUri} className="grid grid-cols-12 gap-3 w-full py-4 cursor-pointer" title={`${parseInt(navItem.surahNumber)}. ${navItem.title} (${getTranslationType(navItem.translationType)} Translation)`}>
                                                        <div className="col-span-12 md:col-span-5 relative md:pl-5 flex items-center">
                                                            <div className="search-arrow-img-elem w-[18px] h-[14px] min-w-[18px] min-h-[14px]"></div>
                                                            <span id="global-surah-title${snum}" className="ml-2 block truncate">{parseInt(navItem.surahNumber)}. {navItem.title} ({getTranslationType(navItem.translationType)} Translation)</span>
                                                        </div>
                                                        <div className="col-span-2 text-center flex items-center hidden md:block">
                                                            <p>Juz {navItem.juz}</p>
                                                        </div>
                                                        <div className="col-span-2 text-center flex items-center justify-center hidden md:block">
                                                            <p>{navItem.ayahCount} Ayahs</p>
                                                        </div>
                                                        <div className="col-span-3 text-center flex items-center justify-center hidden md:block">
                                                            <p>{navItem.arbTitle}</p>
                                                        </div>
                                                    </a>
                                                    <button className="cursor-pointer rounded-full bg-light-blue/10 dark:bg-white/10 h-8 w-8 flex justify-center items-center close-container" onClick={() => closeSearchTile(index,'navigation')}>
                                                        <div className="modal-close-img-elem w-[12px] h-[12px]"></div>
                                                    </button>
                                                </div>
                                            )
                                        }
                                        else if(navItem.hasOwnProperty('tafsirType'))
                                        {
                                            const pageUri=`/quran/tafsir/${navItem.tafsirType}/surah/${parseInt(navItem.surahNumber)}/?resume=${navItem.scrollPos}`;

                                            return(
                                                <div key={index} className="global-surahs search-item">
                                                    <a href={pageUri} className="grid grid-cols-12 gap-3 w-full py-4 cursor-pointer" title={`${parseInt(navItem.surahNumber)}. ${navItem.title} (${navItem.tafsirType==="ibn-kathir"?`Ibn-Kathir`:`Maududi`} Tafsir)`}>
                                                        <div className="col-span-12 md:col-span-5 relative md:pl-5 flex items-center">
                                                            <div className="search-arrow-img-elem w-[18px] h-[14px] min-w-[18px] min-h-[14px]"></div>
                                                            <span id="global-surah-title${snum}" className="ml-2 block truncate">{parseInt(navItem.surahNumber)}. {navItem.title} ({navItem.tafsirType==="ibn-kathir"?`Ibn-Kathir`:`Maududi`} Tafsir)</span>
                                                        </div>
                                                        <div className="col-span-2 text-center flex items-center hidden md:block">
                                                            <p>Juz {navItem.juz}</p>
                                                        </div>
                                                        <div className="col-span-2 text-center flex items-center justify-center hidden md:block">
                                                            <p>{navItem.ayahCount} Ayahs</p>
                                                        </div>
                                                        <div className="col-span-3 text-center flex items-center justify-center hidden md:block">
                                                            <p>{navItem.arbTitle}</p>
                                                        </div>
                                                    </a>
                                                    <button className="cursor-pointer rounded-full bg-light-blue/10 dark:bg-white/10 h-8 w-8 flex justify-center items-center close-container" onClick={() => closeSearchTile(index,'navigation')}>
                                                        <div className="modal-close-img-elem w-[12px] h-[12px]"></div>
                                                    </button>
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </>
                        :
                            <>
                                <p className="text-sm mt-5">Recent navigations:</p>
                                <p className="text-lg bg-light-blue/10 dark:bg-white/10 w-full rounded-md alim-text-color-style my-2 px-3 py-4">No navigation found</p>
                            </>
                    :
                        null
                }

                {
                    matchingHistoryItems&&searchQuery!==""?
                        matchingHistoryItems.length>0?
                            <>
                                <p className="text-sm mt-5">Recently searched:</p>
                                {
                                    matchingHistoryItems.map((matchingItem,itemIndex)=>{
                                        return(
                                            <div key={itemIndex} className="history-surahs search-item">
                                                <a href={`/search-results?s=${matchingItem.searchTerm}&page=1`} className="grid grid-cols-12 gap-3 w-full py-4" target="_blank">
                                                    <div className="col-span-12 relative md:pl-5 flex items-center">
                                                        <div className="search-arrow-img-elem w-[18px] h-[14px]"></div>
                                                        <span className="text-lg ml-2 block">{matchingItem.searchTerm}</span> 
                                                    </div>
                                                </a>
                                                <button className="cursor-pointer rounded-full bg-light-blue/10 dark:bg-white/10 h-8 w-8 flex justify-center items-center close-container" onClick={() => closeSearchTile(itemIndex,'history')}>
                                                    <div className="modal-close-img-elem w-[12px] h-[12px]"></div>
                                                </button>
                                            </div>
                                        )
                                    })
                                }
                            </>
                        :
                            <>
                                <p className="text-sm mt-5">Recently searched:</p>
                                <p className="text-lg bg-light-blue/10 dark:bg-white/10 w-full rounded-md alim-text-color-style my-2 px-3 py-4">
                                    No search history found
                                </p>
                            </>
                    :
                        null
                }
            </div>
            <div className="px-8 alim-text-color-style">
                {
                    searchQuery!==""?
                        <>
                            <p className="text-sm mt-5">Search :</p>
                            <button onClick={()=>{
                                doGlobalSearch(isItAllArabic(searchQuery)?searchQuery:sanitizeSearchString(searchQuery))
                            }} className="text-lg bg-deep-red w-full rounded-md text-white my-2 px-3 py-4 text-left">
                                Search for {isItAllArabic(searchQuery)?searchQuery:sanitizeSearchString(searchQuery)}
                            </button>
                        </>
                    :
                        null
                }
            </div>
        </>
    )
}

export default GlobalSearch;